/** @file Inspector panel: the view of the current target (focus, keys, vertices, bone, slot or project). */
import type { IDockviewPanelProps } from 'dockview-react';
import type { Doc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { useStore } from 'zustand';
import { DocumentPanel } from '../../forms/DocumentPanel';
import { focusStore } from '../../stores/focusStore';
import { selectionStore } from '../../stores/selectionStore';
import { inspectorTarget } from './inspectorTarget';
import { inspectorView } from './inspectorView';
import './inspector.css';

/** Re-renders on document, selection and focus changes only (no 60 fps values). */
function InspectorBody({ doc, t }: { doc: Doc; t: Translate }) {
  const selection = useStore(selectionStore);
  const focus = useStore(focusStore, (s) => s.focus);
  return <div className="p2-inspector" data-testid="panel-inspector">{inspectorView(inspectorTarget(selection, focus, doc), doc, t)}</div>;
}

/** DocumentPanel shows the no-project note. */
export function InspectorPanel({ api }: IDockviewPanelProps) {
  return <DocumentPanel api={api} view={(doc, t) => <InspectorBody doc={doc} t={t} />} />;
}
